// extracted by mini-css-extract-plugin
export default {"scrollTopButton":"scrollToTop_scrollTopButton__SQc7o"};